import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

type StyleProps = {
  hideOnMobile?: boolean
  isSocialIcon?: boolean
}

export const DesktopHeaderCon = styled('div')<StyleProps>(
  ({ hideOnMobile, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      display: hideOnMobile ? 'none' : 'flex',
    },
    '& .row': {
      display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    },
    '& .a': {
      display: 'inline-flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      fontSize: 16,
      fontWeight: 'bold',
      padding: '0 20px',
      color: colors.text,
      borderRight: `1px solid ${colors.lightGrey}`,
      textDecoration: 'none',
      '&:last-of-type ': {
        borderRight: 0,
        paddingRight: 0,
      },
      '& > svg': {
        marginRight: 5,
        width: 20,
        height: 20,
      },
  
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        fontWeight: 'normal',
        padding: '0 12px',
        '& > svg': {
          marginRight: 12,
          width: 20,
          height: 20,
        },
      },
    },
    '& .social': {
      marginLeft: 20,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 12,
      },
      '&:last-child': {
        marginLeft: 10,
      },
      '& > svg': {
        width: 18,
        height: 18,
      },
    },
  })
)

export const DesktopItem = styled('a')<StyleProps>(
  ({ theme }) => ({
      display: 'inline-flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: 16,
      fontWeight: 'bold',
      padding: '0 20px',
      color: colors.text,
      borderRight: `1px solid ${colors.lightGrey}`,
      textDecoration: 'none',
      '&:last-of-type ': {
        borderRight: 0,
        paddingRight: 0,
      },
      '& > svg': {
        marginRight: 10,
        width: 20,
        height: 20,
      },
  
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        fontWeight: 'normal',
        padding: '0 12px',
        '& > svg': {
          marginRight: 12,
          width: 20,
          height: 20,
        },
      }
  })
)

export const MobileTeamHeaderCon = styled('div')(
  ({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  // alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
  '& .a': {
    display: 'flex',
    flexDirection: 'row',
    '& h1': {
      fontWeight: 'bold',
      color: colors.text,
      textDecoration: 'none',
      fontSize: fontSizes.large,
    },
    '& img': {
      margin: theme.spacing(1, 0),
      width: 70,
      height: 70,
    },
  },
}))

export const MobileHeaderCon = styled('div')<StyleProps>(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    '& .a': {
      fontSize: '0.8rem',
      fontWeight: 'normal',
      padding: '0 16px',
      color: '#000',
      textDecoration: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
  
      '& > svg': {
        display: 'block',
        width: 20,
        height: 20,
        marginBottom: 4,
      },
    },
  })
)

export const MobileItem = styled('a')<StyleProps>(
  ({ theme }) => ({
    fontSize: '0.8rem',
    fontWeight: 'normal',
    padding: '0 16px',
    color: '#000',
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& > svg': {
      display: 'block',
      width: 20,
      height: 20,
      marginBottom: 4,
    },
  })
)
